import type { Store } from "vuex";
import type { Poller } from "./scheduler";

const POLL_INTERVAL_MS = 1000 * 60 * 5;

export const createPollers = (store: Store<unknown>): Poller[] => {
  let hasCheckedUnseenAnnouncements = false;

  return [
    {
      name: "pendingUpdates",
      intervalMs: POLL_INTERVAL_MS,
      isEnabled: () => !store.getters["auth/isExternalUser"],
      run: async () => {
        await store.dispatch("notifications/getUnread", { perPage: 5 });

        if (hasCheckedUnseenAnnouncements) {
          return;
        }

        hasCheckedUnseenAnnouncements = true;

        if (store.getters["announcements/hasUnseenAnnouncements"]) {
          store.commit("announcements/setModalVisible", true);
        }
      },
    },
    {
      name: "balance",
      intervalMs: POLL_INTERVAL_MS,
      isEnabled: () => store.getters["auth/isCustomer"],
      run: () => store.dispatch("users/updateCurrentUserOrChildBalanceAfterWhile", 100),
    },
    {
      name: "debtCancellations",
      intervalMs: null,
      retryAttempts: 3,
      isEnabled: () => store.getters["auth/isCustomer"],
      run: ({ isLastAttempt }) =>
        store.dispatch("notifications/getDebtCancellations", { isLastAttempt }),
    },
  ];
};
